import { createSortOption } from "@nosto/preact"
export const sizes = [24, 50, 72]

export const sortOptions = [
    createSortOption("score", "Recommended", { field: "_score", order: "desc" }),
    // createSortOption("date", "Date: New to Old", { field: "datePublished", order: "desc" }),
    createSortOption("date", "New", {field: "extra.upload", order: "desc"}),
    createSortOption("price", "Price: Low to High", { field: "price", order: "asc" }),
    createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
    createSortOption("-rating", "Highest Rated", { field: "ratingValue", order: "desc" })    
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[1],
    autocompleteProductsSize: 6,
    autocompleteKeywordsSize: 5,
    historySize: 5
}

export const gridLayoutOptions = {
    mobile: false,
    desktop: [ 3, 4 ]
}

export const productBadges = [
    { tag: "bb-conscious", text: "Lower Impact", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "bottom-planet-positive", text: "Lower Impact", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "organic-fabric", text: "Organic", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "recylced-fabric", text: "Recycled Fibres", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "vintage-shop", text: "BB Vintage", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "coming-soon", text: "Coming Soon", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "back-in-stock", text: "Back in Stock", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "return:Runs-Small", text: "Runs Small", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "return:Semi-Sheer", text: "Semi Sheer", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "return:Size-Up", text: "Size Up", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "return:Tall-Fit", text: "Tall Fit", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "return:Low-V-Neckline", text: "Low V Neckline ", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "return:Size-Down", text: "Size Down", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "return:Runs-Large", text: "Runs Large", color: "#000", background: "rgba(255, 255, 255, 0.6)" },
    { tag: "stickers:limited-stock", text: "Limited Stock", color: "#000", background: "#fff" },    
    { tag: "stickers:SellingFast", text: "Selling Fast", color: "#000", background: "#fff" },
    { tag: "stickers:Pre-Order", text: "Pre Order", color: "#000", background: "#fff" },
    { tag: "WK46-Promo", text: "Buy 1, Get 1", color: "#000", background: "#FFE9BB" }
    
    
]




export const colors = {
    "acid wash": "#bfc9c9",
    "beige": "#ddccb1",
    "black": "#231f20",
    "black denim": "#231f20",
    "blue": "#0063bc",
    "blush": "#ffcae3",
    "bone": "#f7f7f2",
    "brown": "#563d20",
    "burgundy": "#912a48",
    "bluefloral": "#bdefff",
    "camel": "#a38460",
    "champagne": "#e8d7be",
    "check": "#f1f2f2",
    "checkerboard": "#f1f2f2",
    "chocolate": "#563d20",
    "cream": "#f4f3e1",
    "daisy": "#fff9b1",
    "dark wash denim": "#145794",
    "denim": "#0063bc",
    "emerald": "#155c3e",
    "flame": "#ff0000",
    "floral": "#fff9b1",
    "gingham": "#f1f2f2",
    "gold": "#d8b76c",
    "green": "#67c15d",
    "grey": "#bcbec0",
    "houndstooth": "#bcbec0",
    "indigo": "#0c3c69",
    "ivory": "#f7f7f2",
    "khaki": "#84824e",
    "lemon": "#e1e882",
    "leopard": "#a38460",
    "light wash denim": "#9bc2e5",
    "lilac": "#e4c5df",
    "lime": "#bfe882",
    "mango": "#ff8500",
    "mid wash denim": "#5a98d0",
    "mint": "#bfe882",
    "mocha": "#a38460",
    "multi": "#fef2f7",
    "mustard": "#ff8500",
    "natural": "#f7f7f2",
    "navy": "#0c3c69",
    "neon": "#bfe882",
    "nude": "#fff1dc",
    "oatmeal": "#f7f7f2",
    "olive": "#84824e",
    "orange": "#ff8500",
    "paisley": "#fff9b1",
    "peach": "#ffcc99",
    "pink": "#ff99cc",
    "pinstripe": "#f1f2f2",
    "polka": "#f1f2f2",
    "purple": "#e4c5df",
    "rainbow": "#f1f2f2",
    "red": "#ff0000",
    "red denim": "#ff0000",
    "rose": "#ff99cc",
    "rust": "#ff8500",
    "sage": "#84824e",
    "sequin": "#a7a9ac",
    "silver": "#a7a9ac",
    "speckle": "#a7a9ac",
    "stone": "#f7f7f2",
    "stripe": "#f1f2f2",
    "tan": "#a38460",
    "teal": "#64c4ae",
    "tie dye": "#f1f2f2",
    "tortoiseshell": "#a38460",
    "white": "#f1f2f2",
    "white denim": "#f1f2f2",
    "wine": "#780b2b",
    "yellow": "#fff576",
    "zebra": "#f1f2f2"
};
  
export const sizesOrder = [
    "2", "3", "4", "5", "6", "7", "8", "9", "10", 
    "12", "13", "14", "15", "16", "17", "18", "19", "20", "21",
    "22", "23", "24", "25",

    "XXS", "XXS/XS", "XS", "XS/S", "S", "S/M", "M", "M/L", 
    "L", "L/XL", "XL", "XL/XXL", "XXL", "XXXL", "3XL",

    "Small", "Medium", "Large",

    "ONE SIZE", "One Size", "One size",
    
    "22″", "23″", "24″", "25″", "26″", "27″", 
    "28″", "29″", "30″", "31″", "32″", "34″", "35″",

    "US 0", "US 2", "US 4", "US 5", "US 5.5", "US 6", "US 6.5", "US 7", "US 7.5", "US 8", "US 8.5",
    "US 9", "US 9.5", "US 10", "US 10.5", "US 11", "US 11.5", "US 12", "US 12.5",
    
    "Letter A", "Letter B", "Letter C", "Letter D", "Letter E", "Letter F", "Letter G", 
    "Letter H", "Letter I", "Letter J", "Letter K", "Letter L", "Letter M", "Letter N", 
    "Letter O", "Letter P", "Letter Q", "Letter R", "Letter S", "Letter T", "Letter U", 
    "Letter V", "Letter W", "Letter X", "Letter Y", "Letter Z",
];

export const popularSearches = [
    "Dress",
    "Jeans",
    "Tops",
]

export const noResultLinks = [
    { text: "Shop New", url: "/collections/new" },
    { text: "Shop Dresses", url: "/collections/dresses" },
    { text: "Shop Tops", url: "/collections/tops" },
    { text: "Shop Bottoms", url: "/collections/bottoms" },
    { text: "Shop Shoes", url: "/collections/shoes" },
    { text: "Shop Accessories", url: "/collections/accessories" },
]

export const DROPDOWN_RECID = "searchdropdown-nosto-1";
export const NORESULTS_RECID = "noresults-nosto-1";
export const CATEGORY_RECID = "categorypage-nosto-1";

/* =============== account configs =============== */

export const themes = {
    DEV: {
        yotpoInstanceId: '487239',
        nosto: 'ApGccS2tPxcL5m3FGg6jpg5dTz1c0T6Rk7lNQcRsPgqNe4Nnb6LTwPucLJoKYW3o',
    },
    AU: {
        yotpoInstanceId: '535963',
        nosto: 'ZvU2llUWRcfA68eyJMRB4pIv2gB2cAI2hB7kBgMsjNBRQYhgiS8DHxc9T3guBMHi',
    },
    NZ: {
        yotpoInstanceId: '547740',
        nosto: 'gJ1yDgBNlNLlMX3GOwMho6Aa2wBbcM43GB17sLePsyQX5e8PfcmACy4ESeqKoLTu',
    },
    US: {
        yotpoInstanceId: '547711',
        nosto: 'KLxXObVwzA2nhO9Opo3ryChHOVgHrkKVahP7naTIP7l8q3x9kU865zVQ8H2MuShS',
    }
}[
    (() => {
        const shop = window.Shopify?.shop;

        if (shop === 'beginning-boutique-dev.myshopify.com') {
            return 'DEV'; // Kept the dev check from your original code
        }
        if (shop === 'beginningboutique.myshopify.com') {
            return 'AU';
        }
        if (shop === 'beginningboutique-us.myshopify.com') {
            return 'US';
        }
        if (shop === 'beginningboutique-nz.myshopify.com') {
            return 'NZ';
        }
        
        // Default for all other cases (including Canada "CA")
        return 'US'; 
    })()
]
